import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { HttpService, HttpCall } from '../http-service.service';
import { MatTableDataSource } from '@angular/material/table';
import { FormControl, FormGroup } from '@angular/forms';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { BottomSheetSearchBolliComponent } from '../bottom-sheet-search-bolli/bottom-sheet-search-bolli.component';

import * as _moment from 'moment';
import { Moment } from 'moment';
const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MM/YYYY',
    dateA11yLabel: 'MM/YYYY',
    monthYearA11yLabel: 'MM/YYYY',
  }
};

export interface searchBolliClauses {
  t: string,
  dal: Date,
  al: Date
}

export interface bollo {
  idOperazione: Number,
  dataOperazione: Date,
  idScadenza: Number,
  idVeicolo: string,
  targa: string,
  descrizione: string,
  importo: Number,
  validita: string,
  regione: string,
  dataScadenzaNaturale: Date,
  dataScadenza: Date,
  nuovaDataScadenza: Date
}

@Component({
  selector: 'app-bolli',
  templateUrl: './bolli.component.html',
  styleUrls: ['./bolli.component.scss'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})
export class BolliComponent implements OnInit, AfterViewInit {
  loading:boolean = true;
  displayedColumns: string[] = ['data', 'veicolo', 'regione','scadenza', 'importo'];
  dati: bollo[];
  exportURL:string;
  searchForm: FormGroup;
  search:{
    totalRecords: 0,
    currentPage: 1,
    pageSize: 50,
    importoTotale : 0.0
  };

  constructor(private httpService: HttpService, private _bottomSheet: MatBottomSheet) {
  }

  openBottomSheet(): void {
    this._bottomSheet.open(BottomSheetSearchBolliComponent, { closeOnNavigation: true, data: this.searchForm.value })
      .afterDismissed().subscribe(result => {
        if (result) {
          this.searchForm.controls["t"].setValue(result.t)
          this.searchForm.controls["dal"].setValue(result.dal)
          this.searchForm.controls["al"].setValue(result.al)
          this.applyFilter();
        }
      });
  }

  clearField(field: string, e: Event) {
    if (e) e.stopPropagation();
    this.searchForm.controls[field].setValue('');
    this.applyFilter();
  }

  applyFilter() {
    this.refresh();
  }

  ngOnInit() {
    this.searchForm = new FormGroup({
      t: new FormControl(''),
      dal: new FormControl(''),
      al: new FormControl('')
    })

    this.exportURL = this.httpService.getUrl("enduser/exportB");
    /*this.searchForm.controls["dal"].disable();
    this.searchForm.controls["al"].disable();*/
  }

  ngAfterViewInit() {
    this.refresh();
  }


  setMonth(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>, ctrl: string, end: boolean) {
    var ctrlValue = moment();
    ctrlValue.month(normalizedMonth.month());
    ctrlValue.year(normalizedMonth.year());
    ctrlValue = ctrlValue[end ? "endOf" : "startOf"]("month");
    this.searchForm.controls[ctrl].setValue(ctrlValue);
    datepicker.close();
    this.applyFilter();
  }


  changePage(p){
    this.search.currentPage=p.pageIndex+1;
    this.search.pageSize=p.pageSize;
    this.refresh();
  }

  refresh() {
    this.loading=true;
    let obj = {dal:null,al:null};
    if(this.searchForm.value.dal) obj.dal=moment(this.searchForm.value.dal).toISOString();
    if(this.searchForm.value.al) obj.al=moment(this.searchForm.value.al).toISOString();
    let call: HttpCall = { url: "enduser/bolli", params: Object.assign({}, this.search, this.searchForm.value,obj)}
    //let call: HttpCall = { url: "enduser/bolli" };
    this.httpService.GetJSONContent<any>(call).subscribe(response => {
      this.dati = response.body.dati;
      this.search = response.body.counter;
      this.exportURL = this.httpService.getUrl("enduser/exportB",this.searchForm.value);
      /*this.dataSource = new MatTableDataSource(this.dati);
      this.dataSource.filterPredicate = (data: bollo, filter: string) => {
        let objFilter: any = JSON.parse(filter);
        let ret: boolean = true;
        if (objFilter.t && objFilter.t.trim()) {
          ret = ret && data.targa.toLowerCase().trim().indexOf(objFilter.t.toLowerCase().trim()) >= 0
        }
        if (objFilter.dal) {
          ret = ret && moment(data.dataScadenzaNaturale).toDate() >= moment(objFilter.dal).toDate()
        }
        if (objFilter.al) {
          ret = ret && moment(data.dataScadenzaNaturale).toDate() <= moment(objFilter.al).toDate()
        }
        return ret;
      }*/
    },(e)=>{this.loading=false},()=>{this.loading=false});
  }


}
